// removed by extract-text-webpack-plugin
module.exports = {"large":"1199px","medium":"991px","small":"767px"};


//////////////////
// WEBPACK FOOTER
// ./src/globals.css
// module id = 761
// module chunks = 0